import React from 'react';

import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router-dom';

export const HelpBanner = () => {
    return (
        <Card id="help_banner" className="help-banner py-0">
            <Card.Body className="pt-4 pb-2">
                <Row>
                    <Col className="col-auto">
                        <img src="/img/icons/question-icon.svg" width={74} />
                    </Col>
                    <Col>
                        <h4 className="help-card-title">
                            ARS or Agent360<sup>®</sup> platform questions?
                        </h4>
                        <p>
                            If you have any questions, contact the Foremost<sup>®</sup> territory manager for your area.
                            You can find their <a href="/contact-us" target="_blank">contact information here</a>.
                        </p>
                    </Col>
                    <Col className="text-right float-right col-auto">
                        <Link to="/ask-foremost" className="ml-button-primary external-link white-icon mt-3" target="_blank">
                            Ask Foremost
                        </Link>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default HelpBanner;
